<template>
  <header class="header">
    <div class="header-middle sticky-header">
      <div class="container">
        <div class="header-left">
          <button class="mobile-menu-toggler" type="button">
            <i class="icon-menu"></i>
          </button>
          <router-link :to="{ name: 'Home' }" class="logo">
            <img src="/assets/images/logo.png" alt="Eurosan Logo" />
          </router-link>
        </div>
        <!-- End .header-left -->

        <div class="header-center">
          <div class="header-search">
            <a href="#" class="search-toggle" role="button">
              <i class="icon-magnifier"></i>
            </a>
            <form @submit.prevent.stop="handleSearchSubmit()">
              <div class="header-search-wrapper">
                <input
                  type="search"
                  class="form-control"
                  name="q"
                  id="q"
                  :placeholder="translations.find"
                  v-model="searchInput"
                  @input="handleSearch"
                  @blur="handleBlur()"
                />

                <ul
                  class="article-list bg-body"
                  v-if="showSearchResults && searchInput.length >= 3"
                >
                  <li v-for="article in articles" :key="article.id">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: article.id, slug: slugify(article.title) },
                      }"
                      class="article-wrapper"
                    >
                      <img
                        v-if="article.highlightedImageUrl"
                        :src="`${baseUrl}${article.highlightedImageUrl}`"
                        class="article-image"
                      />

                      <img v-else class="article-image" :src="'img/products/product-8.jpg'" />
                      <div class="article-description">
                        <div class="article-title">
                          {{ article.title }}
                        </div>
                        <div class="article-code">
                          {{ article.code }}
                        </div>
                        <div v-if="(!article.disableSelling && canViewPrices) ||
                          canPassRestrictions" style="display: flex;
                         gap: 1px; align-items: start;">
                          <div
                            class="article-price"
                            v-if="article.salePrice && article.salePrice < article.price"
                          >
                            {{ article.salePrice | money3WithCurrency }}
                            <span
                            class="old-price"
                            v-if="article.salePrice && article.salePrice < article.price"
                          >
                            <del> {{ article.price | money3 }} KM</del>
                          </span>
                          </div>
                          <div class="article-price" v-else>
                            {{ article.price | money3WithCurrency }}
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </li>
                  <li @click="handleSearchSubmit">
                    <a class="article-wrapper">
                      <div class="article-title text-body">Za više rezultata pritisnite Enter</div>
                    </a>
                  </li>
                </ul>

                <button class="btn" type="button" @click="handleSearchSubmit()">
                  <i class="icon-magnifier"></i>
                </button>
              </div>
              <!-- End .header-search-wrapper -->
            </form>
          </div>
          <!-- End .header-search -->
        </div>
        <!-- End .headeer-center -->

        <div class="header-right d-none d-md-flex">
          <div class="header-user">
            <router-link class="position-relative" :to="{ name: 'ProfileDashboard' }">
              <i class="icon-user-2"></i>
              <span class="unread-messages-count position-absolute" v-if="unreadMessageCount > 0">
                {{ unreadMessageCount }}
              </span>
              <!-- <span
                class="
                  position-absolute
                  top-0 start-100
                  translate-middle
                  badge rounded-pill
                  bg-danger
                "
              >
                99+
              </span> -->
            </router-link>
            <div class="header-userinfo">
              <span
                >{{ translations.greetings }} {{ profile.userData.firstName }}! ({{
                  profile.userData.companyTitle.toUpperCase()
                }})</span
              >
              <div class="header-dropdown">
                <h4>
                  <router-link :to="{ name: 'ProfileDashboard' }">
                    {{ translations.myAccount }}
                  </router-link>
                </h4>
                <div class="header-menu">
                  <ul>
                    <li>
                      <router-link exact :to="{ name: 'ProfileDashboard' }">
                        <i class="icon-cog" /> {{ translations.controlPanel }}
                      </router-link>
                    </li>
                    <li>
                      <a href="#" @click.stop.prevent="logOut()">
                        <i class="sicon-logout" /> {{ translations.logout }}
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- End .header-menu -->
              </div>
            </div>
          </div>

          <div class="dropdown cart-dropdown whishlist-dropdown">
            <router-link
              :to="{ name: 'Wishlist' }"
              class="dropdown-toggle wishlist-toggle"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-display="static"
            >
              <i class="icon icon-heart"></i>
              <span class="cart-count wishlist-count" v-if="wishlist.length > 0">
                {{ wishlist.length }}
              </span>
            </router-link>

            <div class="dropdown-menu">
              <div class="dropdownmenu-wrapper">
                <div class="dropdown-cart-header">
                  <span v-if="wishlist.length > 0">{{ wishlist.length }}
                     {{ translations.products }}</span>
                  <span v-else>{{ translations.wishListIsEmpty }}</span>

                  <router-link :to="{ name: 'Wishlist' }">{{ translations.wishlist }}</router-link>
                </div>
                <!-- End .dropdown-cart-header -->
                <vue-custom-scrollbar
                  class="dropdown-cart-products wishlist scroll-area"
                  :settings="scrollbarSettings"
                >
                  <div class="product" v-for="item in wishlist" :key="item.id">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: { id: item.articleId, slug: slugify(item.title) },
                        }"
                      >
                        <Photo :src="`${baseUrl}${item.imageUrl}`" v-if="item.imageUrl" />
                        <Photo src="assets/images/no-image.jpg" v-else />
                      </router-link>
                      <a
                        href="#"
                        class="btn-remove"
                        @click.stop.prevent="toggleWishlistItem(item.articleId)"
                        title="Remove Product"
                      >
                        <i class="icon-retweet"></i>
                      </a>
                    </figure>
                    <div class="product-details">
                      <h4 class="product-title">
                        <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.title) },
                          }"
                        >
                          {{ item.title }}
                        </router-link>
                      </h4>
                      <span>{{ translations.forms.labels.code }}: {{ item.code }}</span>
                    </div>
                    <!-- End .product-details -->
                  </div>
                </vue-custom-scrollbar>
                <!-- End .product -->
                <!-- End .cart-product -->
              </div>
              <!-- End .dropdownmenu-wrapper -->
            </div>
            <!-- End .dropdown-menu -->
          </div>

          <div class="dropdown cart-dropdown">
            <router-link
              :to="{ name: 'ShoppingCart' }"
              class="dropdown-toggle"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-display="static"
            >
              <i class="minicart-icon"></i>
              <span class="cart-count" v-if="cart && cart.cartItems">
                {{ cart.cartItems.length || 0 }}
              </span>
            </router-link>

            <div class="dropdown-menu" v-if="cart && cart.cartItems">
              <div class="dropdownmenu-wrapper">
                <div class="dropdown-cart-header">
                  <span>{{ cart.cartItems.length }} {{ translations.products }}</span>
                  <router-link :to="{ name: 'ShoppingCart' }">{{
                    translations.shoppingCart
                  }}</router-link>
                </div>
                <!-- End .dropdown-cart-header -->
                <div class="dropdown-cart-products wishlist scroll-area">
                  <div class="product" v-for="item in cart.cartItems" :key="item.id">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: { id: item.articleId, slug: slugify(item.article) },
                        }"
                      >
                        <img
                          :src="`${baseUrl}${item.highlightedImageUrl}`"
                          v-if="item.highlightedImageUrl"
                          alt="product"
                        />
                        <img src="assets/images/no-image.jpg" v-else alt="product" />
                      </router-link>
                      <a href="#" class="btn-remove" @click.stop.prevent="removeFromCart(item.id)">
                        <i class="icon-retweet" />
                      </a>
                    </figure>
                    <div class="product-details">
                      <h4 class="product-title">
                        <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.article) },
                          }"
                        >
                          {{ item.article }}
                        </router-link>
                      </h4>
                      <div>{{ translations.forms.labels.code }}:
                        {{ item.variation?.article?.code ?? item.code }}
                      </div>

                      <span class="cart-product-info" v-if="canViewPrices">
                        <span class="cart-product-qty">{{ item.quantity }}</span>
                        x {{ item.price | money3WithCurrency }}
                      </span>
                    </div>
                    <!-- End .product-details -->
                  </div>
                  <!-- End .product -->
                </div>
                <!-- End .cart-product -->

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.totalWithoutTax }}</span>
                  <span class="cart-total-price">
                    {{ cart.totalAmountWithoutVat.toFixed(2) }} KM
                  </span>
                </div>

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.totalTax }}</span>
                  <span class="cart-total-price">{{ cart.totalAmountVat.toFixed(2) }} KM</span>
                </div>

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.total }}</span>
                  <span class="cart-total-price">{{ cart.totalAmount.toFixed(2) }} KM</span>
                </div>
                <!-- End .dropdown-cart-total -->

                <div class="dropdown-cart-action">
                  <router-link :to="{ name: 'Checkout' }" class="btn btn-block">
                    {{ translations.checkout }}
                  </router-link>
                </div>
                <!-- End .dropdown-cart-total -->
              </div>
              <!-- End .dropdownmenu-wrapper -->
            </div>
            <!-- End .dropdown-menu -->
          </div>
          <!-- End .dropdown -->
        </div>
        <!-- End .header-right -->
      </div>
      <!-- End .container -->
    </div>
    <!-- End .header-middle -->

    <div class="header-bottom">
      <div class="container">
        <nav class="main-nav">
          <div class="menu-depart" @click="toggleMenu">
            <a><i class="icon-menu"></i>{{ translations.categories.toUpperCase() }}</a>
          </div>
          <ul class="menu">
            <router-link :to="{ name: 'Home' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.homePageTitle }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'MyArticles' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate"> {{ translations.myArticles }} </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Orders' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.orders }}
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Brands' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate"> {{ translations.brands }} </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Sales' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.sales }}
                  <span
                    class="badge badge-pill position-absolute sales-badge"
                    v-if="sales.length > 0"
                  >
                    {{ sales.length }}
                  </span>
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Blogs' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.news }}
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'About' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.aboutUs }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'Contact' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.contact }}
                </a>
              </li>
            </router-link>
          </ul>
        </nav>
        <a href="https://webshop.eurosan.ba/">
          <div class="ml-auto b2c-button">
            {{ translations.physicalPersons }}
          </div>
        </a>

        <div class="header-dropdowns"
         v-if="!useDefaultLanguage && defaultLanguages">
          <div class="header-dropdown">
            <a href="#">{{ lang.shortTitle.toUpperCase() }}</a>
            <div class="header-menu">
              <ul>
                <li
                  v-for="lang in defaultLanguages"
                  :key="lang.id"
                >
                <a href="#" @click="setLanguage(lang.id)">
                  {{ lang.title.toUpperCase() }}
                </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="categories && categories.length > 0">
        <div class="sub-menu-container">
          <ul id="submenu-height" class="submenu" :class="{ opened: menuActive }">
            <li class="main-category" v-for="item in categories" :key="item.id">
              <router-link
                class="main-category-label"
                @click.native="hideMenu()"
                :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }"
              >
                {{ item.label }} <i class="icon-angle-right" />
              </router-link>
              <div class="main-menu-open" v-if="item.children && item.children.length > 0">
                <div class="col-12">
                  <div class="category-wrapper">
                    <div class="sub-category-wrapper" v-for="sub in item.children" :key="sub.id">
                      <div>
                        <router-link
                          @click.native="hideMenu()"
                          :to="{
                            name: 'Category',
                            params: {
                              id: sub.id,
                              slug: sub.slug,
                            },
                          }"
                        >
                          {{ sub.label }}
                        </router-link>
                      </div>

                      <ul
                        class="menu-column-3-level"
                        v-if="sub.children && sub.children.length > 0"
                      >
                        <li v-for="subSub in sub.children" :key="subSub.id">
                          <router-link
                            @click.native="hideMenu()"
                            :to="{
                              name: 'Category',
                              params: {
                                id: subSub.id,
                                slug: subSub.slug,
                              },
                            }"
                          >
                            {{ subSub.label }}
                          </router-link>
                        </li>
                        <li>
                          <router-link
                            @click.native="hideMenu()"
                            :to="{ name: 'Category', params: { id: sub.id, slug: sub.slug } }"
                            class="text-underline"
                          >
                            {{ translations.viewAll }} <i class="icon-angle-right" />
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <router-link
                    :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }"
                    class="view-all"
                  >
                    {{ translations.viewAllFrom }} {{ item.label }}
                  </router-link>
                </div>
                <!-- <div class="col-lg-4 d-lg-block d-sm-none no-gaps">
                  <div class="menu-column">
                    <img style="margin-left: auto" src="assets/images/banners/menu-banner.jpg" />
                  </div>
                </div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- End .header-bottom -->
    </div>
    <!-- End .header-bottom -->
    <div>
      <!-- Bottom navigation for mobile -->
      <div class="fixed-bottom d-md-none bg-light border-top custom-bottom-bar">
        <div class="container d-flex justify-content-between">
          <div class="row text-center d-flex justify-content-between col-12">
            <!-- Home Section -->
            <div class="col-2 ml-2">
              <router-link :to="{ name: 'Home' }" class="bottom-nav-link">
                <i style="font-size: 18px" class="icon-home"></i>
                <a style="font-size: 9px; white-space: nowrap">{{ translations.homePageTitle }}</a>
              </router-link>
            </div>

            <!-- Profile Section -->
            <div class="col-2">
              <router-link :to="{ name: 'ProfileDashboard' }" class="bottom-nav-link">
                <i class="icon-user-2"></i>
                <a style="font-size: 9px; white-space: nowrap">{{ translations.myProfile }}</a>
              </router-link>
            </div>

            <!-- Wishlist Section -->
            <div class="col-2">
              <router-link :to="{ name: 'Wishlist' }" class="bottom-nav-link position-relative">
                <i class="icon icon-heart"></i>
                <a style="font-size: 9px; white-space: nowrap">{{ translations.wishlist }}</a>
                <span
                  class="badge badge-pill badge-danger position-absolute wishlist-badge"
                  v-if="wishlist.length > 0"
                >
                  {{ wishlist.length }}
                </span>
              </router-link>
            </div>

            <!-- Shopping Cart Section -->
            <div class="col-2">
              <router-link :to="{ name: 'ShoppingCart' }" class="bottom-nav-link position-relative">
                <i class="icon-bag"></i>
                <a style="font-size: 9px; white-space: nowrap">{{ translations.shoppingCart }}</a>
                <span
                  class="badge badge-pill badge-danger position-absolute cart-badge"
                  v-if="cart && cart.cartItems && cart.cartItems.length > 0"
                >
                  {{ cart.cartItems.length }}
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { debounce } from 'lodash';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import './scrollbar.css';

import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';

import { translations, categoryMenu } from '@/mixins';
import Photo from '@/components/shared/Image.vue';

export default {
  name: 'Header',
  components: {
    vueCustomScrollbar,
    Photo,
  },
  mixins: [translations, categoryMenu],
  data() {
    return {
      scrollbarSettings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      showSearchResults: false,
      searchInput: '',
    };
  },
  computed: {
    categories() {
      return this.$store.getters.getCategoriesTreeView;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    baseUrl() {
      return config.baseUrl;
    },
    articles() {
      return (this.$store.getters.getSearchArticles || {}).articles || [];
    },
    route() {
      return this.$route.name;
    },
    unreadMessageCount() {
      return this.$store.getters.getUnreadMessagesCount;
    },
    sales() {
      return this.$store.getters.getArticlesOnSale;
    },
    useDefaultLanguage() {
      return this.$store.getters.getUseDefaultLanguage;
    },
    defaultLanguage() {
      return this.$store.getters.getDefaultLanguage;
    },
    defaultLanguages() {
      return this.$store.getters.getLanguages.map((lang) => ({
        ...lang,
        title: this.languages.find((item) => item.id === lang.id)?.title || lang.title,
        shortTitle: this.languages.find((item) => item.id === lang.id)?.shortTitle
        || lang.shortTitle,
      }));
    },
  },
  methods: {
    slugify,
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getWishList');
      });
    },
    logOut() {
      api.logout().finally(() => {
        localStorage.removeItem('token');
        this.$router.push({ name: 'Login' });
      });
    },
    removeFromCart(cartItemId) {
      api.removeFromCart(cartItemId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
      });
    },
    handleSearchSubmit() {
      if (
        this.searchInput.trim().length < 3
        || (this.$route.name === 'Search'
        && this.$route.params.search.trim().toLowerCase() === this.searchInput.trim().toLowerCase())
      ) {
        return;
      }
      this.$router.push({ name: 'Search', params: { search: this.searchInput } });
      this.handleBlur();
    },
    handleBlur: debounce(function blur() {
      this.searchInput = '';
      this.showSearchResults = false;
    }, 300),
    handleSearch: debounce(function search() {
      // Needs to enter minimun 3 characters to perform search
      if (this.searchInput.trim().length < 3) return;

      this.showSearchResults = true;
      this.$store.dispatch('getQuickSearch', {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        pageSize: 5,
        quickSearch: this.searchInput.trim(),
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      });
    }, 300),
  },
  mounted() {
    this.$store.dispatch('getWishList');
    this.$store.dispatch('getUnreadMessagesCount');
    Porto.stickyHeader();
  },
  watch: {
    useDefaultLanguage(value) {
      if (value) {
        const defaultLanguage = this.$store.getters.getDefaultLanguage;
        localStorage.setItem('langId', defaultLanguage);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// .whishlist-dropdown {
//   line-height: 0.5rem;
//   margin-top: 4px;
// }
/* Custom styles for the bottom bar */

// mobilni prikaz

.custom-bottom-bar {
  height: 55px;
  padding-top: 10px;
  z-index: 1030;
}

.bottom-nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.85rem;
  color: #000;
  text-decoration: none;
}

.bottom-nav-link:hover {
  color: #007bff;
}

.bottom-nav-link i {
  font-size: 2.5rem;
}

.wishlist-badge,
.cart-badge {
  top: 0px;
  right: 10px;
  font-size: 0.85rem;
}

.sales-badge {
  top: 11px;
  right: 29px;
  font-size: 0.85rem;
  height: 10px;
  width: 10px;
  background-color: #e27c7c;
  color: #e27c7c;
}

@media screen and (max-width: 1269px) {
  .sales-badge {
    top: -3px;
    right: 0px;
    font-size: 0.85rem;
    height: 9px;
    width: 9px;
    background-color: #e27c7c;
    color: #e27c7c;
  }
}

// mobilni prikaz kraj

.sub-menu-container {
  background: transparent;
  border: none;
  width: 275px;
  // width: 100%;
}

.submenu {
  margin-left: 20px;
  background: transparent;
  border: #f0f0f0;

  &:hover {
    width: 100%;
  }

  li.main-category {
    display: flex;
    height: 31.7px;
    color: #767f84;
    line-height: 1.4;
    border: #f0f0f0;

    &:hover {
      background: #1e84bc;
      color: #fff;

      .main-menu-open {
        display: flex;
        left: 0;
      }
    }

    a.main-category-label {
      padding-left: 8px;
      color: #212529;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-basis: 100%;
      margin: 0 1rem;
      text-transform: uppercase;
      font-size: 1.3rem;
      color: #212529;
      font-weight: 600;
      border-bottom: none;

      &:hover {
        color: #fff;

        i {
          color: #fff;
        }
      }

      i {
        color: #212529;
        font-weight: 600;
        font-size: 1.9rem;
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .submenu {
    margin-left: 10px;
  }
}

.main-category {
  width: 275px;
  color: #767f84;
  background: #fff;
}

.main-menu-open {
  display: none;
  position: absolute;
  top: 0;
  width: calc(100% - 275px);
  bottom: 0;
  background: #fff;
  transition: all 2s;
}

.menu-depart {
  color: #fff !important;

  a {
    color: #fff !important;
    font-weight: bold !important;
  }

  .icon-menu {
    color: #fff !important;
  }
}

#submenu-height {
  border-top: 1px solid #e7e7e7;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.09);
  border-bottom: 6px solid #1e84bc;
}
.category-wrapper {
  color: #222529;
  font: 600 1.5rem /1.1 'Open Sans', sans-serif;
  letter-spacing: 0.01em;
  text-transform: none;
  padding-top: 10px;
  columns: 3;
  // rows: 5;
  column-gap: 40px;
  height: 100%;

  .sub-category-wrapper {
    padding-bottom: 20px;
    width: 100%;
    break-inside: avoid;
    color: #212529;

    a {
      display: inline-block;
      margin-bottom: 1.5rem;
      color: #212529;
      font-weight: bold;
      font-size: 14px;
      transition: all 0.5s;

      &:hover {
        color: #1e84bc;
      }
    }
  }
}

.menu-column-3-level li a {
  font: 600 1.2rem 'Open Sans', sans-serif !important;
  line-height: 20px;
  height: 20px;
  // color: #777 !important;
  color: #212529;
  cursor: pointer;
  padding: 0 !important;
  margin: 0 !important;
  text-transform: none !important;
}
.text-underline {
  text-decoration: underline;
}

.view-all {
  position: absolute;
  right: 10px;
  bottom: 20px;
  text-transform: uppercase;
  font-size: 18px;
  color: #222529;
  padding: 0 10px 5px 10px;
  border-bottom: 1px solid #777;
  font-size: 14px;
  color: #777;
  transition: all 0.5s;

  &:hover {
    color: #1e84bc;
    border-bottom: 1px solid #1e84bc;
  }
}

.cart-dropdown .dropdown-toggle .cart-count.wishlist-count {
  right: 12px;
}

.wishlist-toggle {
  i {
    font-size: 27px;
  }
}

.dropdown-menu {
  z-index: 1002;
}

.dropdown-cart-products.wishlist {
  max-height: 450px;
  overflow: auto;
}

@media screen and (max-width: 1479px) {
  .main-category {
    width: 230px;
  }

  .main-menu-open {
    width: calc(100% - 230px);
  }
}

.article-list {
  position: absolute;
  margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1020;
  left: 0;
  top: 50px;
  width: 100%;
  background: #fff;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    opacity: 0.75;

    &:first-child {
      border-top: none;
    }

    &:hover {
      opacity: 1;
      .article-title {
        color: #259ddf;
        text-decoration: underline;
      }
    }
  }
}
.article-wrapper {
  display: flex;
  flex-basis: 50%;
}

.article-description {
  display: flex;
  flex-direction: column;
  height: 80px;
  color: #777;
}

.article-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 5px;
}

.product-image {
  display: block;
  width: 70px;
  height: 70px;
}

.product-image-container {
  margin-right: 5px;
}

.article-title,
.article-code,
.article-price {
  width: 100%;
  font-size: 16px;
  flex-basis: 50%;
}

.sticky-header {
  margin-right: 0 !important;
}

.cart-dropdown .dropdown-toggle .minicart-icon {
  border: 2px solid #1e84bc;
}

.cart-dropdown .dropdown-toggle .minicart-icon:hover {
  border: 2px solid black;
}

.unread-messages-count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  right: 1.25rem;
  top: 0;
  border-radius: 50%;
  padding-bottom: 3px;
  font-size: 1rem;
  font-weight: 600;
  background-color: #ed7e63;
  color: #fff;
  box-shadow: 0 7px 8px rgb(0 0 0 / 5%);
}

.icon-cog,
.sicon-logout {
  font-size: 1.5rem !important;
  border: none;
}

.dropdown-cart-header,
.dropdown-cart-total {
  padding: 0.25rem 1rem;
  font-size: 13px;
}

.dropdown-cart-total .cart-total-price {
  font-size: 13px;
}

.b2c-button {
  background-color: #1e84bc;
  color: white;
  padding-inline: 17px;
  padding-block: 8px;
  font: 400 13px 'Poppins', 'Open Sans', sans-serif;
}

.b2c-button:hover {
  background-color: #259ddf !important;
}

@media (max-width: 991px) {
  .header-bottom {
    display: none;
  }
}
</style>
